"use client";
import { useEffect, useState } from "react";

function useSessionStorage(key: string) {
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(sessionStorage.getItem(key) ?? "");
  }, [key]);

  return value;
}

export default useSessionStorage;
